import { render, staticRenderFns } from "./expertHome.vue?vue&type=template&id=3126b5bd&scoped=true&"
import script from "./expertHome.vue?vue&type=script&lang=js&"
export * from "./expertHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126b5bd",
  null
  
)

export default component.exports